import React from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { isEmpty } from 'lodash';

import SubNavbar from '../components/SubNavbar';
import ActionButton from '../../ActionButton';
import { getRouteName } from '../../../utils/routesNames';
import { routes } from '../../../pages';

import './_merchantsNav.scss';

const MerchantsNav = () => {
  const { pathname } = useLocation();
  const { dataTable } = useSelector(s => s.merchants);
  const { data: { is_group_admin } } = useSelector(s => s.account);

  return (
    <div className="merchantsNav">
      <SubNavbar route={`${getRouteName(pathname)} ${!isEmpty(dataTable) ? '(' + dataTable.length + ')' : ''}`}>
        {is_group_admin && <ActionButton variant="secondary" title="Add merchant" to={routes.merchants.add.path}/>}
      </SubNavbar>
    </div>
  );
};

export default MerchantsNav;